<template>
  <div class="cta-cards">
    <a :href="cellWhatsappLink" target="_blank" class="cta-card cta-cell">
      <img src="../assets/illustrations/community.svg" alt="" class="cta-illustration" />
      <div class="cta-content">
        <span class="cta-badge">Comunidade</span>
        <h3>Encontre uma Célula</h3>
        <p>Faça parte de um grupo que vai transformar sua caminhada</p>
        <span class="cta-btn">
          <i class="fa fa-whatsapp"></i>
          Quero participar
        </span>
      </div>
    </a>

    <a :href="volunteerWhatsappLink" target="_blank" class="cta-card cta-volunteer">
      <img src="../assets/illustrations/volunteer.svg" alt="" class="cta-illustration" />
      <div class="cta-content">
        <span class="cta-badge">Sirva</span>
        <h3>Seja um Voluntário</h3>
        <p>Use seus dons para fazer a diferença na casa de Deus</p>
        <span class="cta-btn">
          <i class="fa fa-whatsapp"></i>
          Quero servir
        </span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'CtaCards',
  props: {
    churchInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    cellWhatsappLink() {
      const number = this.churchInfo.whatsapp_pastoral || '5599981103560'
      return `https://wa.me/${number}?text=Olá! Gostaria de encontrar uma célula perto de mim.`
    },
    volunteerWhatsappLink() {
      const number = this.churchInfo.whatsapp_volunteer || '5599988133510'
      return `https://wa.me/${number}?text=Olá! Gostaria de ser voluntário na igreja.`
    }
  }
}
</script>

<style scoped>
.cta-cards {
  display: flex;
  gap: 20px;
  width: 100%;
  max-width: 1080px;
}

.cta-card {
  flex: 1;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  padding: 36px 32px;
  text-decoration: none;
  color: #fff;
  min-height: 200px;
  display: flex;
  align-items: flex-end;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.cta-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}

.cta-cell {
  background: #2d6a4f;
}

.cta-volunteer {
  background: #3a5ba0;
}

.cta-illustration {
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 55%;
  opacity: 0.12;
  pointer-events: none;
}

.cta-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cta-badge {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  opacity: 0.7;
}

.cta-content h3 {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.cta-content p {
  font-size: 14px;
  opacity: 0.8;
  line-height: 1.4;
  margin: 0;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  width: fit-content;
  transition: background 0.2s ease;
}

.cta-card:hover .cta-btn {
  background: rgba(255, 255, 255, 0.3);
}

.cta-btn .fa {
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  .cta-cards {
    flex-direction: column;
  }

  .cta-card {
    min-height: 170px;
    padding: 28px 24px;
  }

  .cta-content h3 {
    font-size: 20px;
  }

  .cta-illustration {
    width: 45%;
    right: -5px;
  }
}
</style>
